/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';

/**
 * 
 * @export
 * @interface TournamentSplashHeroUiModuleBody
 */
export interface TournamentSplashHeroUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof TournamentSplashHeroUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentSplashHeroUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentSplashHeroUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentSplashHeroUiModuleBody
     */
    moduleType: TournamentSplashHeroUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof TournamentSplashHeroUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof TournamentSplashHeroUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof TournamentSplashHeroUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof TournamentSplashHeroUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof TournamentSplashHeroUiModuleBody
     */
    title: LocalizedFieldBody;
    /**
     * 
     * @type {string}
     * @memberof TournamentSplashHeroUiModuleBody
     */
    tournamentId: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentSplashHeroUiModuleBody
     */
    tournamentReferenceId?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum TournamentSplashHeroUiModuleBodyModuleTypeEnum {
    TOURNAMENT_SPLASH_HERO = 'TOURNAMENT_SPLASH_HERO'
}



